module.exports = __webpack_public_path__ + "img/img_page_05_01.f66a29b2.png";